import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CreateApplicationDetailsCmConstants } from "./create-application-details-cm.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { take, takeUntil } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
import { GraveSearchService } from "src/app/tabs/graves/shared/services/grave-search.service";
import { MapService } from "src/app/map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { StepMetadataConstants } from "../../../../../core/settings/components/step-metadata/step-metadata.constants";
let CreateApplicationDetailsCmComponent = class CreateApplicationDetailsCmComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    graveSearchService;
    mapService;
    requestStatusService;
    recipientSelectService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsCmConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = CreateApplicationDetailsCmConstants.DESCRIPTION_FORM_CONTROL_NAME;
    burialTypeFormControlName = CreateApplicationDetailsCmConstants.BURIAL_TYPE_FORM_CONTROL_NAME;
    burialDateFormControlName = CreateApplicationDetailsCmConstants.BURIAL_DATE_FORM_CONTROL_NAME;
    funeralParlourFormControlName = CreateApplicationDetailsCmConstants.FUNERAL_PARLOUR_FORM_CONTROL_NAME;
    cemeteryFormControlName = CreateApplicationDetailsCmConstants.CEMETERY_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsCmConstants.DESCRIPTION_LABEL;
    burialTypeLabel = CreateApplicationDetailsCmConstants.BURIAL_TYPE_LABEL;
    burialDateLabel = CreateApplicationDetailsCmConstants.BURIAL_DATE_LABEL;
    cemeteryLabel = CreateApplicationDetailsCmConstants.CEMETERY_LABEL;
    funeralParlourDisableFilterBy = false;
    funeralParlourDisableAdd = true;
    funeralParlourDisableEditing = false;
    funeralParlourShowFields = true;
    funeralParlourIsInternal = false;
    funeralParlourGroups = [];
    funeralParlourLabel = CreateApplicationDetailsCmConstants.FUNERAL_PARLOUR_LABEL;
    applicationTypes = [];
    defaultGraveStatus = [];
    editableFields = CreateApplicationDetailsCmConstants.EDITABLE_RECIPIENT_FIELDS;
    cemeteriesSubscription;
    setMapLayerSubscription;
    cemeteries = [];
    defaultCemetery = {
        cemeteryName: CreateApplicationDetailsCmConstants.DEFAULT_CEMETERY_NAME,
        cemeteryId: null,
        cemeteryObjectId: null
    };
    constructor(createApplicationService, aflaModuleStrategyService, graveSearchService, mapService, requestStatusService, recipientSelectService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.graveSearchService = graveSearchService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
            this.funeralParlourGroups = this.recipientSelectService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
                this.defaultGraveStatus = this.aflaModuleStrategyService.lookups.get("defaultGraveStatus");
                this.cemeteries = this.aflaModuleStrategyService.lookups.get("cemeteries");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
    }
    ngAfterViewInit() {
        const funeralParlourForm = this.detailsForm.get("funeralParlour");
        if (this.detailsForm.get(this.funeralParlourFormControlName).value) {
            const funeralParlourValues = (this.detailsForm.get(this.funeralParlourFormControlName).value);
            this.editableFields.forEach((field) => {
                Object.entries(funeralParlourValues).forEach((funeralParlourKey) => {
                    if (field === funeralParlourKey[0] && funeralParlourKey[1] !== null) {
                        funeralParlourForm.enable();
                    }
                });
            });
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getCemeteries() {
        this.requestStatusService.showBusySpinner("Getting cemeteries");
        this.createApplicationService.getModuleMaps(+this.appController.selectedModuleID).pipe(take(1)).subscribe({
            next: (moduleMapsResult) => {
                const moduleMaps = moduleMapsResult.value;
                let cemeteryModuleMap = null;
                let graveModuleMap = null;
                for (const moduleMap of moduleMaps) {
                    if (moduleMap.selectionLayerType === "Cemetery") {
                        cemeteryModuleMap = moduleMap;
                    }
                    if (moduleMap.selectionLayerType === "Grave") {
                        graveModuleMap = moduleMap;
                    }
                }
                if (cemeteryModuleMap !== null && graveModuleMap !== null) {
                    const gravesIds = this.defaultGraveStatus.map(item => `GraveStatus='${item.value}'`);
                    const gravesQueryWhere = gravesIds.join(" or ");
                    const gravesQueryReturnGeometry = false;
                    const gravesQueryOutFields = "CemeteryID";
                    const gravesQueryReturnDistinctValues = true;
                    const cemeteryQueryWhere = `1=1`;
                    const cemeteryQueryReturnGeometry = false;
                    const cemeteryQueryOutFields = "*";
                    const proxyUrl = ApiProxyConstants.URL;
                    let graveQueryUrl = "";
                    if (graveModuleMap.url.endsWith("/")) {
                        graveQueryUrl = "query";
                    }
                    else {
                        graveQueryUrl = "/query";
                    }
                    const graveUrl = `${graveModuleMap.url}${graveQueryUrl}?where=${gravesQueryWhere}&returnGeometry=${gravesQueryReturnGeometry}&outFields=${gravesQueryOutFields}&returnDistinctValues=${gravesQueryReturnDistinctValues}&f=json`;
                    let cemeteryQueryUrl = "";
                    if (cemeteryModuleMap.url.endsWith("/")) {
                        cemeteryQueryUrl = "query";
                    }
                    else {
                        cemeteryQueryUrl = "/query";
                    }
                    const cemeteryUrl = `${cemeteryModuleMap.url}${cemeteryQueryUrl}?where=${cemeteryQueryWhere}&returnGeometry=${cemeteryQueryReturnGeometry}&outFields=${cemeteryQueryOutFields}&f=json`;
                    const proxyGavesUrl = `${proxyUrl}?${encodeURIComponent(graveUrl)}`;
                    const proxyCemeteryUrl = `${proxyUrl}?${encodeURIComponent(cemeteryUrl)}`;
                    forkJoin([this.createApplicationService.queryMapViaProxy(proxyCemeteryUrl, cemeteryModuleMap.id),
                        this.createApplicationService.queryMapViaProxy(proxyGavesUrl, graveModuleMap.id)])
                        .pipe(take(1))
                        .subscribe({
                        next: data => {
                            const cemeteryFeatureSet = data[0];
                            const gravesFeatureSet = data[1];
                            if (gravesFeatureSet?.features?.length > 0) {
                                const gravesIds = gravesFeatureSet.features.map(item => this.propertyDataAlternateColumnName(item.attributes, "CemeteryID", "cemeteryid"));
                                if (cemeteryFeatureSet?.features?.length > 0) {
                                    const filteredCemeteries = cemeteryFeatureSet.features
                                        .map(item => ({
                                        cemeteryName: this.propertyDataAlternateColumnName(item.attributes, "Name", "name"),
                                        cemeteryId: this.propertyDataAlternateColumnName(item.attributes, "OBJECTID", "objectid"),
                                        cemeteryObjectId: null
                                    }))
                                        .filter(cemetery => gravesIds.includes(cemetery.cemeteryId));
                                    this.cemeteries = [
                                        this.defaultCemetery,
                                        ...filteredCemeteries
                                    ];
                                    this.cemeteries = [
                                        this.cemeteries[0],
                                        ...this.cemeteries.slice(1).sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName))
                                    ];
                                    this.aflaModuleStrategyService.lookups.set("cemeteries", this.cemeteries);
                                    this.detailsForm.get(this.cemeteryFormControlName).setValue(this.defaultCemetery);
                                    this.changeDetectorRefs.detectChanges();
                                }
                            }
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                        },
                        error: error => {
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                            this.appController.handleServerErrorMessage(StepMetadataConstants.STEP_TITLE, error, CRUDOperation.Get);
                        }
                    });
                }
                else {
                    this.requestStatusService.removeBusySpinner("Getting cemeteries");
                }
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("Getting cemeteries");
                this.appController.handleServerErrorMessage(CreateApplicationDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    loadMetadata(stepMeta) {
        this.funeralParlourGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.funeralParlourGroup);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ApplicationType' or name eq 'DefaultGraveStatus')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const defaultGraveStatus = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "DefaultGraveStatus") {
                    defaultGraveStatus.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        defaultGraveStatus.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.aflaModuleStrategyService.lookups.set("defaultGraveStatus", defaultGraveStatus);
        this.applicationTypes = applicationTypes;
        this.defaultGraveStatus = defaultGraveStatus;
        this.getCemeteries();
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: GraveSearchService },
        { type: MapService },
        { type: RequestStatusService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsCmComponent = __decorate([
    Component({
        selector: "app-create-application-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsCmComponent);
export { CreateApplicationDetailsCmComponent };
